module.exports = __webpack_public_path__ + "img/v.7152839a.jpg";